// extracted by mini-css-extract-plugin
export default {"progres":"Progres_progres__VBmYd","title":"Progres_title__-KQTm","progressBar":"Progres_progressBar__TdbFy","progressBarLine":"Progres_progressBarLine__of5U+"};